import Link from '~/src/common/components/Link';
import { logger } from '~/src/common/services/Logger';
import Tracker from '~/src/common/services/Tracker';

import useBreadcrumb from './hooks/useBreadcrumb';
import * as S from './layout';
import type { Item } from './types';

type Props = {
  item: Nullable<Item>;
  categoryIdOrSlug?: Nullable<string>;
};

const Breadcrumb = ({ item = null, categoryIdOrSlug = null }: Props) => {
  const crumbs = useBreadcrumb(item, categoryIdOrSlug);
  if (crumbs.length === 0) return null;

  const getClickHandler = (level: number) => () => {
    if (level === 0) Tracker.sendEvent('click breadcrumb level 0');
    else if (level === 1) Tracker.sendEvent('click breadcrumb level 1');
    else if (level === 2) Tracker.sendEvent('click breadcrumb level 2');
    else logger.warning(`Breadcrumb level ${level} not tracked`);
  };

  return (
    <S.Container role="navigation">
      <S.List>
        {crumbs.map((crumb, index) => (
          <S.Item key={index} data-type={crumb.type}>
            {crumb.link ? (
              <Link href={crumb.link} onClick={getClickHandler(index)}>
                {crumb.name}
              </Link>
            ) : (
              <span>{crumb.name}</span>
            )}
          </S.Item>
        ))}
      </S.List>
    </S.Container>
  );
};

export default Breadcrumb;
